import { Injectable } from "@angular/core";
import { UseCase } from "../../base";
import { Observable } from "rxjs";
import { PlanRulesTemplateRepository } from "../../repositories/plan-rules-template.repository";
import { EditPlanRulesTemplateRequest } from "../../domain";
@Injectable({ providedIn: 'root' })
export class EditPlanRulesTemplateUsecase implements UseCase<EditPlanRulesTemplateRequest, string> {

  constructor(private readonly planRulesTemplateRepository: PlanRulesTemplateRepository) {
  }

  execute(params: EditPlanRulesTemplateRequest): Observable<string> {
    return this.planRulesTemplateRepository.EditPlanRulesTemplate(params);
  }
}
